import TRANSLATIONS_MODE from './constants';
import TranslationsTable from './TranslationsTable';

const ClientPanelTranslations = () => (
  <TranslationsTable catalog={TRANSLATIONS_MODE.clientPanel} />
);

export default ClientPanelTranslations;
